import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "list", "template", "hint"];

  connect() {
    this.files = [];
    this.render();
  }

  addFiles(event) {
    const incomingFiles = Array.from(event.target.files || []);
    this.files = this.files.concat(incomingFiles);
    this.syncInputFiles();
    this.render();
  }

  removeFile(event) {
    const index = Number(event.currentTarget.dataset.index);
    this.files.splice(index, 1);
    this.syncInputFiles();
    this.render();
  }

  syncInputFiles() {
    const dataTransfer = new DataTransfer();
    this.files.forEach((file) => dataTransfer.items.add(file));
    this.inputTarget.files = dataTransfer.files;
  }

  render() {
    if (!this.hasListTarget) return;

    this.listTarget.innerHTML = "";

    this.files.forEach((file, index) => {
      const item = this.buildListItem(file.name, index);
      this.listTarget.appendChild(item);
    });

    if (this.hasHintTarget) {
      this.hintTarget.classList.toggle("d-none", this.files.length === 0);
    }
  }

  buildListItem(fileName, index) {
    if (this.hasTemplateTarget) {
      const fragment = this.templateTarget.content.cloneNode(true);
      const item = fragment.querySelector("li");
      const name = fragment.querySelector("[data-role='filename']");
      const removeButton = fragment.querySelector("[data-role='remove']");

      if (name) name.textContent = fileName;
      if (removeButton) removeButton.dataset.index = index;

      return item;
    }

    const fallbackItem = document.createElement("li");
    fallbackItem.className = "list-group-item d-flex justify-content-between align-items-center";

    const nameSpan = document.createElement("span");
    nameSpan.textContent = fileName;

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "btn btn-sm btn-outline-danger";
    removeButton.dataset.action = "multi-file-upload#removeFile";
    removeButton.dataset.index = index;
    removeButton.textContent = "Remove";

    fallbackItem.appendChild(nameSpan);
    fallbackItem.appendChild(removeButton);

    return fallbackItem;
  }
}
